const emptyGroup = {
  id: 0,
  name: '',
  permissions: [],
};

export default emptyGroup;
